import {
  Box,
  Button,
  Grid,
  styled,
  SxProps,
  Text,
  Theme,
} from '@ltvco/refresh-lib/theme';
import React from 'react';

export const BannerContainer: React.ComponentType<
  React.ComponentProps<typeof Box>
> = styled(Box)(({ theme }) => ({
  width: '100%',
  height: 'max-content',
  marginBottom: '28px',
  paddingTop: '16px',
  paddingRight: '40px',
  paddingBottom: '16px',
  paddingLeft: '40px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 24,
  position: 'relative',
  overflow: 'hidden',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '12px',
  [theme.breakpoints.down('sm')]: {
    borderRadius: '10px',
    width: '100%',
    flexDirection: 'column',
    padding: '20px 16px',
    gap: '24px',
  },
}));

export const HeaderSection: React.ComponentType<
  React.ComponentProps<typeof Box>
> = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
}));

export const StyledBannerImage: React.ComponentType<
  React.ComponentProps<'img'>
> = styled('img')(() => ({
  height: '250px',
  transform: 'translateX(-10px)',
  display: 'block',
}));

export const StyledBannerIcon: React.ComponentType<
  React.ComponentProps<'img'>
> = styled('img')(({ theme }) => ({
  height: '58px',
  transform: 'translateX(-10px)',
  display: 'block',
  [theme.breakpoints.down('sm')]: {
    height: '78px',
  },
}));

export const StyledBannerContent: React.ComponentType<
  React.ComponentProps<typeof Box>
> = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: 2,
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '40px',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const StyledTextContainer: React.ComponentType<
  React.ComponentProps<typeof Box>
> = styled(Box)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '16px',
  width: '700px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const StyledFeatures: React.ComponentType<
  React.ComponentProps<typeof Grid>
> = styled(Grid)(({ theme }) => ({
  height: 'auto',
  width: '45%',
  display: 'flex',
  gap: 12,
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const StyledFeaturesContainer: React.ComponentType<
  React.ComponentProps<typeof Grid>
> = styled(Grid)(({ theme }) => ({
  height: 'auto',
  width: '100%',
  gridColumn: 2,
  gap: 12,
  padding: 12,
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  borderRadius: '10px',
  backgroundColor: theme.palette.background.default,
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const StyledHeaderText: React.ComponentType<
  React.ComponentProps<typeof Text>
> = styled(Text)(({ theme }) => ({
  fontSize: '24px',
  fontWeight: 700,
  color: theme.palette.text.primary,
  margin: 0,
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
  },
}));

export const StyledBodyText: React.ComponentType<
  React.ComponentProps<typeof Text>
> = styled(Text)(({ theme }) => ({
  fontSize: '16px',
  lineHeight: '24px',
  color: theme.palette.text.secondary,
  textAlign: 'left',
  margin: 0,
  maxWidth: '700px',
}));

export const StyledButton: React.ComponentType<
  React.ComponentProps<typeof Button>
> = styled(Button)(() => ({
  height: '42px',
  width: 'max-content',
}));

export const BackgroundShapesContainer: React.ComponentType<
  React.ComponentProps<typeof Box>
> = styled(Box)(() => ({
  position: 'absolute',
  right: 0,
  bottom: 0,
  overflow: 'hidden',
  borderRadius: '12px',
  zIndex: 0,
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
}));

interface StyledBackgroundImageProps extends React.ComponentProps<'img'> {
  sx?: SxProps<Theme>;
}

export const StyledBackgroundImage: React.FC<StyledBackgroundImageProps> =
  styled('img')(({ width, height }) => ({
    width: width ?? 'auto',
    height: height ?? '100%',
    objectFit: 'cover',
    display: 'block',
    zIndex: 1,
  }));
